// local.ts

declare global {
  interface Window {
    locale?: 'en' | 'ar'
  }
}

class LocalhostSettings {
  setLanguage(lang: 'en' | 'ar') {
    window.locale = lang
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr'
    localStorage.setItem('lang', lang)
  }

  getLanguage(): 'en' | 'ar' {
    return window.locale || (localStorage.getItem('lang') as 'en' | 'ar') || 'en'
  }

  isRTL(): boolean {
    return this.getLanguage() === 'ar'
  }
}

const localhostSettings = new LocalhostSettings()
export default localhostSettings
